<template>
  <div class="container py-3">
    <!-- Header -->
    <h2 class="fs-4 fw-bold mb-3 text-center">Fulfill Stock</h2>

    <!-- Loading / Error -->
    <div v-if="loadingItem" class="alert alert-info text-center">Loading item...</div>
    <div v-else-if="!currentItem" class="alert alert-danger text-center">
      Item not found or unauthorized
    </div>

    <!-- Item Card -->
    <div v-else class="card shadow-sm border-0 rounded-3 p-3">
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">SKU</label>
          <input
            type="text"
            class="form-control form-control-lg"
            :value="currentItem.SKU"
            disabled
          />
        </div>
        <!-- Disabled item info -->
        <div class="mb-3">
          <label class="form-label">Item Name</label>
          <input
            type="text"
            class="form-control form-control-lg"
            :value="currentItem.productName"
            disabled
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Available Quantity</label>
          <input
            type="text"
            class="form-control form-control-lg"
            :value="currentItem.totalCount"
            disabled
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Location</label>
          <input
            type="text"
            class="form-control form-control-lg"
            :value="currentItem.location"
            disabled
          />
        </div>

        <!-- Editable fulfill qty -->
        <div class="mb-3">
          <label class="form-label">Quantity to Fulfill</label>
          <input
            type="number"
            v-model="fulfilledQty"
            min="1"
            :max="currentItem.totalCount"
            class="form-control form-control-lg"
          />
        </div>

        <!-- Note / Remarks -->
        <div class="mb-3">
          <label class="form-label">Remarks / Notes (optional)</label>
          <textarea
            v-model="note"
            rows="3"
            class="form-control form-control-lg"
            placeholder="Enter any remarks here..."
          ></textarea>
        </div>

        <button class="btn btn-primary w-100 py-2" @click="submitFulfillment">
          Submit Fulfillment
        </button>
      </div>
    </div>

    <!-- Login Modal -->
    <div
      v-if="showLogin"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5);"
    >
      <div class="modal-dialog modal-dialog-centered" style="max-width: 400px;">
        <div class="modal-content rounded-3 shadow">
          <div class="modal-header border-0">
            <h5 class="modal-title fw-bold">Login Required</h5>
            <button type="button" class="btn-close" @click="showLogin = false"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input type="email" v-model="loginEmail" class="form-control form-control-lg" />
            </div>
            <div class="mb-3">
              <label class="form-label">Password</label>
              <input
                type="password"
                v-model="loginPassword"
                class="form-control form-control-lg"
              />
            </div>
          </div>
          <div class="modal-footer border-0">
            <button class="btn btn-secondary w-50" @click="showLogin = false">Cancel</button>
            <button class="btn btn-primary w-50" @click="handleLogin" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth"
import axios from "axios"
import { useToast } from 'vue-toastification'

export default {
  name: "FulfillStock",
  data() {
    return {
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      currentItem: null,
      fulfilledQty: 1,
      note: "",
      loginEmail: "",
      loginPassword: "",
      loading: false,
      loadingItem: true,
      showLogin: false,
    }
  },
  created() {
    this.initPage()
  },
   setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    getStoredToken() {
      const token = localStorage.getItem("exactflosuite_authToken")
      const expiry = localStorage.getItem("exactflosuite_authExpiry")

      if (!token || !expiry) return null
      if (Date.now() > parseInt(expiry)) {
        localStorage.removeItem("exactflosuite_authToken")
        localStorage.removeItem("exactflosuite_authExpiry")
        return null
      }
      return token
    },
    async initPage() {
      const token = this.getStoredToken()
      if (token) {
        await this.fetchItem(token)
      } else {
        this.loadingItem = false
        this.showLogin = true
      }
    },
    async fetchItem(token) {
      this.loadingItem = true
      try {
        const res = await axios.get(`${this.apiURL}/api/inventory/${this.$route.params.id}`, {
          headers: { Authorization: `${token}` },
        })
        this.currentItem = res.data
      } catch (err) {
        console.error(err)
        this.currentItem = null
      } finally {
        this.loadingItem = false
      }
    },
    async handleLogin() {
      if (!this.loginEmail || !this.loginPassword) {
        alert("Please enter email and password")
        return
      }
      this.loading = true
      try {
        const auth = getAuth()
        await setPersistence(auth, browserLocalPersistence)
        const userCredential = await signInWithEmailAndPassword(
          auth,
          this.loginEmail,
          this.loginPassword
        )

        const token = await userCredential.user.getIdToken()
        const payload = JSON.parse(atob(token.split(".")[1]))
        const expiry = payload.exp * 1000

        localStorage.setItem("exactflosuite_authToken", token)
        localStorage.setItem("exactflosuite_authExpiry", expiry)

        this.showLogin = false
        this.loginEmail = ""
        this.loginPassword = ""

        await this.fetchItem(token)
      } catch (err) {
        alert("Login failed: " + err.message)
      } finally {
        this.loading = false
      }
    },
    async submitFulfillment() {
      if (!this.fulfilledQty || this.fulfilledQty <= 0) {
        alert("Enter a valid quantity")
        return
      }

      const token = this.getStoredToken()
      if (!token) {
        this.showLogin = true
        return
      }

      try {
        await axios.post(
          `${this.apiURL}/api/inventory/transaction`,
          {
            itemId: this.currentItem.id,
            quantity: this.fulfilledQty,
            note: this.note,
            type: "fulfilment",
          },
          {
            headers: { Authorization: `${token}` },
          }
        )

        this.toast.success("Fulfillment successful")
        this.note = "" // clear note after submit
        await this.fetchItem(token) // refresh stock
      } catch (err) {
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("exactflosuite_authToken")
          localStorage.removeItem("exactflosuite_authExpiry")
          this.showLogin = true
        } else {
          alert("Error: " + (err.response?.data?.error || err.message))
        }
      }
    },
  },
}
</script>
